import {Injectable} from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd, ResolveEnd} from '@angular/router';

@Injectable()
export class AuthNavGuard implements CanActivate {

  constructor(private router: Router) {}

  clearCache(current) {
    for (let i = 0; i < sessionStorage.length; i++) {
      if (current.indexOf(sessionStorage.key(i)) > -1) {
        return;
      }
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        const url = val.url.split('/');
        url.shift();
        this.clearCache(url);
      }
    });

    const token = localStorage.getItem('token');
    if (token) { return true }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
    return false;
  }
}
